module.exports = __webpack_public_path__ + "img/judicial.710f6cbe.png";